import { Event } from "../../../pojo/Event";
import { Proto } from "../../../pojo/Proto";
import { S25Util } from "../../../util/s25-util";
import { EventListMicroI } from "../../s25-event/EventMicroI";
import { AccountSummaryMetrics } from "../reference-set-pricing/account-summary/account-summary-metrics";

export namespace OrgEventSearch {
    /** The `YYYYMMDD` an event search wants, rather than the punctuated ISO date everything else uses. */
    export function toSearchDate(date: Date): Proto.ISODateString {
        return (S25Util.date.toS25ISODateStr(date) ?? "").replace(/-/g, "") as Proto.ISODateString;
    }

    export function params(orgId: number, range: AccountSummaryMetrics.DateRange): Event.WsQueryParams {
        return {
            organization_id: [orgId],
            start_dt: toSearchDate(range.start),
            end_dt: toSearchDate(range.end),
            node_type: "E",
            order: "desc",
        };
    }

    export function byStartDateDesc(first: EventListMicroI, second: EventListMicroI): number {
        return (second.dates?.startDate ?? "").localeCompare(first.dates?.startDate ?? "");
    }
}
